import * as React from "react";

// icons
import "font-awesome/css/font-awesome.min.css";

import "./assessmentViewPage.scss";
import { Animated } from "react-animated-css";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

// services
import {
  createItemGen,
  currentBaseUrl,
  currentLessonAttempt,
  currentLesson,
  currentUser,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
  setProfileData,
  setUpgradedAssessmentComplete,
} from "../../common/services";

// interfaces
import { IAssessmentAnswer } from "../../common/interfaces";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";
import PLEXLoader from "../../components/PlexLoader/Loader";

// assessment components
import UpgradedQuestionCollection from "../../common/upgradedQuestionCollection.Component";
import ProgressBar from "../../common/progressBar.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import AssessmentQuestion from "src/common/assessmentQuestion.Component";
import dragDropIcon from "../../assets/images/dragdrop-icon.png";

import { CircleSlider } from "react-circle-slider";
import Modal from "react-awesome-modal";
import lessonicon from "../../assets/images/courseicons/math-icon.png";
import { CircularProgressbar } from "react-circular-progressbar";
import { FiRepeat } from "react-icons/fi";
import { GiCalendar } from "react-icons/gi";
import { GiAlarmClock } from "react-icons/gi";
import { IoMdClose, IoIosArrowForward } from "react-icons/io";
import StarRatings from "react-star-ratings";

import Rater from "react-rater";

import "react-rater/lib/react-rater.css";
import withServices from 'src/HOCs/withServices';

export interface Istate {
  activeStep: number;
  classes: any;
  theme: any;
}

interface IProps {
  history?: any;
  isActive?: any;
  // services: any
}

const Star = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512.002 512.002"
    >
      <path
        fill={color}
        d="M511.267 197.258a14.995 14.995 0 0 0-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 0 0-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 0 0-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0 0 21.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0 0 21.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 0 0 3.795-15.375z"
      />
    </svg>
  );
};

const Sad = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 526 526"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M437.02 74.98C388.667 26.629 324.38 0 256 0S123.333 26.629 74.98 74.98C26.629 123.333 0 187.62 0 256s26.629 132.667 74.98 181.02C123.333 485.371 187.62 512 256 512s132.667-26.629 181.02-74.98C485.371 388.667 512 324.38 512 256s-26.629-132.667-74.98-181.02zm-21.214 340.826C373.12 458.492 316.367 482 256 482s-117.12-23.508-159.806-66.194S30 316.367 30 256 53.508 138.88 96.194 96.194 195.633 30 256 30s117.12 23.508 159.806 66.194S482 195.633 482 256s-23.508 117.12-66.194 159.806z"
      />
      <path
        fill={color}
        d="M256 271.552c-65.876 0-119.471 53.595-119.471 119.471h30c0-49.334 40.137-89.471 89.471-89.471s89.471 40.137 89.471 89.471h30c0-65.877-53.595-119.471-119.471-119.471zM214.773 158.594h-30c0 14.009-11.397 25.406-25.406 25.406s-25.406-11.397-25.406-25.406h-30c0 30.551 24.855 55.406 55.406 55.406s55.406-24.855 55.406-55.406zM352.633 184c-14.009 0-25.406-11.397-25.406-25.406h-30c0 30.551 24.855 55.406 55.406 55.406s55.406-24.855 55.406-55.406h-30c0 14.009-11.397 25.406-25.406 25.406z"
      />
    </svg>
  );
}

const Smile = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm0 480C132.288 480 32 379.712 32 256S132.288 32 256 32s224 100.288 224 224-100.288 224-224 224z"
      />
      <path
        fill={color}
        d="M176 176c17.673 0 32 14.327 32 32h32c0-35.346-28.654-64-64-64-35.346 0-64 28.654-64 64h32c0-17.673 14.327-32 32-32zM336 144c-35.346 0-64 28.654-64 64h32c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32h32c0-35.346-28.654-64-64-64zM256 368c-53.019 0-96-42.981-96-96h-32c0 70.692 57.308 128 128 128s128-57.308 128-128h-32c0 53.019-42.981 96-96 96z"
      />
    </svg>
  );
};
const Happy = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm0 480C132.288 480 32 379.712 32 256S132.288 32 256 32s224 100.288 224 224-100.288 224-224 224z"
      />
      <path
        fill={color}
        d="M176 176c17.673 0 32 14.327 32 32h32c0-35.346-28.654-64-64-64-35.346 0-64 28.654-64 64h32c0-17.673 14.327-32 32-32zM336 144c-35.346 0-64 28.654-64 64h32c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32h32c0-35.346-28.654-64-64-64zM368 256H144c-8.837 0-16 7.163-16 16 0 70.692 57.308 128 128 128s128-57.308 128-128c0-8.837-7.163-16-16-16zM256 368c-46.869.031-86.909-33.787-94.72-80h189.44c-7.811 46.213-47.851 80.031-94.72 80z"
      />
    </svg>
  );
};

const Normal = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
      <path fill={color} d="M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm0 480C132.288 480 32 379.712 32 256S132.288 32 256 32s224 100.288 224 224-100.288 224-224 224z" />
      <circle fill={color} cx="176" cy="176" r="32" />
      <circle fill={color} cx="336" cy="176" r="32" />
      <path fill={color} d="M144 304h224v32H144z" />
    </svg>
  );
};


const Angry = ({ isActive }: IProps) => {
  const color = isActive ? "#8BC34A" : "#E3E3E3";
  return (
    <svg width="24px" height="24px" viewBox="0 0 526 526">
      <g fill="none" transform="translate(13.000000, 13.000000)">
        <circle
          id="Face"
          stroke={color}
          strokeWidth="25"
          cx="250"
          cy="250"
          r="250"
        />
        <path
          d="M146.766617,170 L178.873712,191.656509 C179.607424,194.254283 180,196.995188 180,199.827784 C180,216.396326 166.568542,229.827784 150,229.827784 C133.431458,229.827784 120,216.396326 120,199.827784 C120,184.351657 131.718691,171.612577 146.766617,170 Z"
          id="Combined-Shape"
          fill={color}
        />
        <path
          d="M346.766617,170 L378.873712,191.656509 C379.607424,194.254283 380,196.995188 380,199.827784 C380,216.396326 366.568542,229.827784 350,229.827784 C333.431458,229.827784 320,216.396326 320,199.827784 C320,184.351657 331.718691,171.612577 346.766617,170 Z"
          id="Combined-Shape"
          fill={color}
          transform="translate(350.000000, 199.913892) scale(-1, 1) translate(-350.000000, -199.913892) "
        />
        <path
          d="M150,330 C182.874349,356.234375 216.059245,369.351562 249.554688,369.351562 C283.05013,369.351562 316.85612,356.234375 350.972656,330"
          id="Mouth"
          stroke={color}
          strokeWidth="25"
          strokeLinecap="round"
          transform="translate(250.486328, 349.675781) scale(1, -1) translate(-250.486328, -349.675781) "
        />
      </g>
    </svg>
  );
};

const scoreText = (score) => {
  return Math.round(score) > 0 ? `${Math.round(score)}%` : 'KEEP TRYING';
}
class UpgradedAssessmentViewPage extends React.Component<any> {
  public state = {
    answer: "",
    answerOptions: [],
    assessment: {},
    assessmentfields: {
      info: "assessment_info",
      questions: "questions",
      session: "assessment_session",
      preassess: "Preassess",
    },
    assessmenttitle: "",
    baseurl: currentBaseUrl(),
    counter: 0,
    currenticon: "em-fearful",
    emojiIcons: {
      1: "em-smiley",
      2: "em-smile",
      3: "em-sweat",
      4: "em-neutral_face",
      5: "em-fearful",
    },
    interactions: 0,
    loaded: false,
    question: "",
    questionId: 1,
    questiontime: new Date().getTime(),
    responses: [] as IAssessmentAnswer[],
    result: "",
    slidervalue: 0,
    timetaken: 0,
    tocompleted: false,
    todashboard: false,
    tologin: false,
    toProfile: false,
    total: 0,
    modalIsOpen: true,
    assessmentPerformance: {} as any,
    rating: 0,
    performanceSummary: [] as any,
    responseLoaded: false,
    submitClicked: false,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.setUserAnswer = this.setUserAnswer.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.increaseCounterClearAns = this.increaseCounterClearAns.bind(this);
    this.loadQuestion = this.loadQuestion.bind(this);
    this.submitAnswers = this.submitAnswers.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.renderAssessment = this.renderAssessment.bind(this);
    this.renderCompletedPage = this.renderCompletedPage.bind(this);
    this.chooseRender = this.chooseRender.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openWidget = this.openWidget.bind(this);
    this.feedbackModal = this.feedbackModal.bind(this);
    this.openHome = this.openHome.bind(this);
    this.toDataCenter = this.toDataCenter.bind(this);
    this.changeRating = this.changeRating.bind(this);
    this.feelRating = this.feelRating.bind(this);
  }

  public onLogout(arg) {
    this.setState({ tologin: true });
  }

  public onProfile() {
    this.setState({ toProfile: true });
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  public closeModal() {
    this.setState({ modalIsOpen: false });
  }
  public openWidget(param, e) {
    // this.setState({ destination: currentBaseUrl()  + 'preassessmentresult/'  + param });
    // this.setState({ navigate: true });
    // console.log("AFTER ASSESSMENT" + this.state.destination);
  }
  public toDataCenter() {
    const { history } = this.props;
    history.push(`/students/datacentre`);
  }
  public openHome() {
    this.setState({ todashboard: true });
  }

  public onLogoClick() { return; }

  public handleGenSmartDataLoaded(res) {
    if (res.code === 200) {
      this.setState({ loaded: true });
      this.setState({ assessment: res.response });
      this.loadQuestion();
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleGenCreatedItemLoaded(res) {
    if (res.code === 200) {
      toast("Well done!");
      this.setState({ loaded: true });
      // setProfileData(res.response.profile);
      setUpgradedAssessmentComplete();
      this.setState({
        assessmentPerformance: res.response,
        performanceSummary: res.response.summary,
        responseLoaded: true,
        submitClicked: false
      });
      // this.setState({ tocompleted: true });
    }

    if (res.code === 404) {
      toast.error("Request failed, try again");
      this.setState({ loaded: false });
    }
    if (res.code === 401) {
      toast.warn("Request unauthorized");
      this.onLogout("arg");
    }
    if (res.code === 404) {
      toast.error("Request failed, try again");
      this.setState({ loaded: false });
    }
  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {
      if (this.currentid() === "0") {
        this.closeModal();
      }

      if (
        isBasicPreassessmentDone() &&
        !isUserUpgraded() &&
        this.currentid() === "0"
      ) {
        this.setState({ todashboard: true });
      } else if (isUserUpgraded() && this.currentid() === "0") {
        this.setState({ todashboard: true });
      } else {
        getGeneralSmartTableData(
          "admin/assessments/request_assessment/?id=" + this.currentid(),
          (text) => this.handleGenSmartDataLoaded(text)
        );
        this.setState({ username: currentUser() });
      }
    }
  }

  public handleAnswerSelected(value) {
    if (isNaN(value)) {
      value = 0;
    }
    this.setState({ slidervalue: value });
    const maxindex = this.state.answerOptions.length - 1;
    const selectedindex = Math.round((value / 100) * maxindex);
    const idkey = "id";
    const ickey = "Icon";
    const answerid = this.state.answerOptions[selectedindex][idkey];
    const currenticon = this.state.answerOptions[selectedindex][ickey];
    this.setState({ currenticon });
    this.setUserAnswer(answerid);
  }
  public async changeRating(newRating) {
    // this.setState({ rating: newRating.rating });
    const ratingRes = await this.props.services.studentsAPI.rateLessonContent({
      lesson_id: currentLesson().id,
      rating: newRating.rating,
    });
    if (ratingRes.ok) {
      console.log(ratingRes);
    }
  }

  public async feelRating(newRating) {
    const ratingRes = await this.props.services.studentsAPI.rateLessonFeeling({
      lesson_id: currentLesson().id,
      rating: newRating.rating,
    });
    if (ratingRes.ok) {
      console.log("Rating Noted");
    }
  }

  public lessonPerformanceComment = (score) => {
    if (score > 70) {
      return "Wow, you nailed this lesson!";
    } else {
      return "Great job, but there's still room to improve";
    }
  };

  public async submitAnswers() {
    this.state.responses.push(this.generateResponse());
    this.setState({ loaded: false, submitClicked: true });

    const currentlesson = currentLesson();

    const formData = new FormData();

    const jsonse = JSON.stringify(this.state.responses)


    const responseBlob = new Blob([jsonse], { type: 'application/json' });

    formData.append("files", responseBlob);
    formData.append("lessonattempt", currentlesson.sessionKey);
    formData.append("session", this.state.assessment[this.state.assessmentfields.session]);


    const submitRes = await this.props.services.adminAPI.submitUpgradedAssessmentResponsesBinary(formData, '1234');

    this.increaseCounterClearAns();


    if (submitRes.ok) {

      toast("Well done!");
      this.setState({ loaded: true });
      // setProfileData(res.response.profile);

      setUpgradedAssessmentComplete();

      this.setState({
        assessmentPerformance: submitRes.data,
        performanceSummary: submitRes.data.summary,
        responseLoaded: true,
        submitClicked: false
      });

      // this.setState({ loaded: false, assessmentProcessing: true });

      // setProfileData(res.response.profile.Profiledata);
      // setPreAssessmentComplete()
      // setTimeout(() => { this.setState({ tocompleted: true, submitClicked: false }) }, 2000);
    } else {
      toast.error("Request failed, try again");

    }

    this.setState({ loaded: true, submitClicked: false });

  }

  public setUserAnswer(answer) {
    // console.log(answer);
    const newinteractioncount = this.state.interactions + 1;
    this.setState({
      answer: answer + "",
      interactions: newinteractioncount,
    });
  }

  public increaseCounterClearAns() {
    const newcount = this.state.counter + 1;
    this.setState({
      answer: "",
      counter: newcount,
      slidervalue: 0,
    });
  }

  public loadQuestion() {
    const ickey = "Icon";
    this.setState({
      answerOptions: this.state.assessment[
        this.state.assessmentfields.questions
      ][this.state.counter].answers,
      assessmenttitle: this.state.assessment[this.state.assessmentfields.info]
        .Title,
      interactions: 0,
      slidervalue: 0,
      currenticon: "em-angry",
      question: this.state.assessment[this.state.assessmentfields.questions][
        this.state.counter
      ].Question,
      questionId: this.state.assessment[this.state.assessmentfields.questions][
        this.state.counter
      ].id,
      questiontime: new Date().getTime(),
      total: this.state.assessment[this.state.assessmentfields.questions]
        .length,
    });
  }

  public generateResponse() {
    const timespent = Math.floor(
      ((new Date().getTime() - this.state.questiontime) % (1000 * 60)) / 1000
    );
    return {
      answer: this.state.answer,
      answeredtime: new Date().getTime(),
      interactions: this.state.interactions,
      question: this.state.questionId,
      timeon: timespent,
    } as IAssessmentAnswer;
  }
  public nextQuestion() {
    if (
      this.state.counter <
      this.state.assessment[this.state.assessmentfields.questions].length
    ) {
      this.state.responses.push(this.generateResponse());
      this.increaseCounterClearAns();
      setTimeout(() => this.loadQuestion(), 300);
    } else {
      // route to assessment complete page uncomment the line below
      // commented to sort the routing btn upgraded, preupgrade and lessonAssessmentResults
      this.setState({ tocompleted: true });
    }
  }

  public nextButton() {
    if (this.state.assessment[this.state.assessmentfields.questions]) {
      if (
        this.state.counter <
        this.state.assessment[this.state.assessmentfields.questions].length - 1
      ) {
        return (
          <button
            className="next-button"
            disabled={this.state.answer.length < 1}
            onClick={this.nextQuestion}
          >
            Continue
          </button>
        );
      } else {
        return (
          <button
            className="next-button"
            disabled={this.state.answer.length < 1}
            onClick={this.submitAnswers}
          >
            Submit
          </button>
        );
      }
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <h2>Assessment not found</h2>
          <i className="fa fa-frown-o" style={{ fontSize: 300 }} />
          <p>
            This assessment does not exist please go{" "}
            <a href={this.state.baseurl + "home"}>Home</a> and try again
          </p>
        </div>
      );
    }
  }

  public renderAssessment() {
    const LoaderStyles = {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    return (
      <div className="assessment-main-container">
        {this.state.submitClicked ? (
          <div style={LoaderStyles}>
            <PLEXLoader width={450} height={300} loaderId={7} />
          </div>
        ) : (
          <Loader
            loaded={this.state.loaded}
            style={{ width: "80%", overflowY: "scroll" }}
          >
            <div className="assessment-wrapper">
              {/* <h2 className="assessment-title">
                      {this.state.assessmenttitle}
                    </h2> */}
              <div className="breadcrumb-progress-bar">
                {/* <p className="go-back"> &lt; Back </p> */}
                <ProgressBar
                  fraction={this.state.counter}
                  total={this.state.total}
                  showLabel={true}
                />
              </div>
              <Animated
                animationIn="fadeIn"
                animationOut="zoomOut"
                isVisible={true}
                animationInDuration={800}
              >
                <AssessmentQuestion
                  content={this.state.question}
                  qnNumber={this.state.counter + 1}
                />
              </Animated>
              <div className="questions-container">
                <div className="assessment-slider-wrapper">
                  <div className="assessment-thumb">
                    <div className="main-emoji">
                      <i className={"em-svg " + this.state.currenticon} />
                    </div>
                    <div className="circular-slider">
                      <CircleSlider
                        value={this.state.slidervalue}
                        size={320}
                        // showTooltip={true}
                        circleWidth={36}
                        progressWidth={30}
                        circleColor="#999"
                        progressColor="#acff24"
                        knobRadius={25}
                        knobColor="#eee"
                        min={0}
                        max={100}
                        stepSize={1}
                        onChange={this.handleAnswerSelected}
                      />
                    </div>
                  </div>
                  <div className="assessment-slider-instruction">
                    <img src={dragDropIcon} alt="Drag and Drop Icon" />
                    <p>Slide</p>
                  </div>
                </div>

                <UpgradedQuestionCollection
                  answer={this.state.answer}
                  answerOptions={this.state.answerOptions}
                  questionId={this.state.questionId}
                  question={this.state.question}
                  questionTotal={this.state.total}
                  // onAnswerSelected={this.handleAnswerSelected}
                  sliderValue={this.state.slidervalue}
                  currentIcon={this.state.currenticon}
                  emojiIcons={this.state.emojiIcons}
                  // prop for number of current qn
                  currentQuestion={this.state.counter + 1}
                />
              </div>
            </div>
          </Loader>
        )}

        <footer className="assessment-footer">{this.nextButton()}</footer>
      </div>
    );
  }
  public actionbuttons() {
    if (isUserUpgraded()) {
      return (
        <div className="button-list">
          <button
            className="completed-button green-button"
            onClick={this.openHome}
          >
            My Dashboard
          </button>
          <br />
        </div>
      );
    } else {
      return (
        <div className="button-list">
          <button
            className="completed-button green-button"
            onClick={this.openWidget.bind(this, "student")}
          >
            {" "}
            My Assessment
          </button>
          <br />
        </div>
      );
    }
  }
  public feedbackModal() {
    const {
      assessmentPerformance,
      performanceSummary,
      loaded,
      responseLoaded,
    } = this.state;
    let date;
    if (responseLoaded) {
      date = new Date(performanceSummary[0].answeredtime);
    }
    if (isUserUpgraded() && loaded) {
      const progressStyles = {
        path: {
          stroke: "#acff24",
        },
        trail: {
          stroke: "#000",
        },
        text: {
          fill: "#acff24",
        },
      };
      const interactionScore = assessmentPerformance.interaction_score;
      const assessmentScore = assessmentPerformance.assessment_percentage_score;

      const scoreStyles = (score) => ({
        path: {
          stroke: score > 0 ? "#acff24" : "#ff0033",
        },
        trail: {
          stroke: "#000",
        },
        text: {
          fill: score > 0 ? "#acff24" : "#ff0033",
          fontSize: score > 0 ? "20px" : "12px",
        },
      });
      return (
        <Modal
          visible={this.state.modalIsOpen}
          effect="fadeInUp"
          backgroundColor="blue"
          styles={{ backgroundColor: "transparent" }}
          container={{ background: "#ff0033" }}
          onClickAway={this.closeModal}
          width="80%"
        >
          <div className="success-modal-container">
            <div className="success-modal-content">
              <div className="success-modal-content-header">
                <img src={lessonicon} alt="Lesson Icon" />
                <h1>Here's how you performed</h1>
              </div>
              <h5>{this.lessonPerformanceComment(interactionScore)}</h5>
              <div className="success-modal-content-statistics">
                <div className="stats-col">
                  <h6>Questions Answered</h6>
                  <CircularProgressbar
                    value={100}
                    text={`${100}%`}
                    styles={progressStyles}
                  />
                </div>
                <div className="stats-col">
                  <h6>Intellect Score</h6>
                  <CircularProgressbar
                    value={Math.round(interactionScore)}
                    text={scoreText(interactionScore)}
                    styles={scoreStyles(interactionScore)}
                  />
                </div>
                <div className="stats-col">
                  <h6>Emotional Score</h6>
                  <CircularProgressbar
                    value={Math.round(assessmentScore)}
                    text={scoreText(assessmentScore)}
                    styles={scoreStyles(assessmentScore)}
                  />
                </div>
                <div className="stats-col">
                  <div className="stat-more-info">
                    <FiRepeat size="36px" color="#ff0033" />
                    <p>{assessmentPerformance.total_attempts} attempts</p>
                  </div>
                  <div className="stat-more-info">
                    <GiAlarmClock size="36px" color="#ff0033" />
                    <p>
                      {Math.floor(assessmentPerformance.time_taken / 60)} Mins{" "}
                      {Math.ceil(assessmentPerformance.time_taken % 60)} Sec
                    </p>
                  </div>
                  {responseLoaded ? (
                    <div className="stat-more-info">
                      <GiCalendar size="36px" color="#ff0033" />
                      <p>{`${date.getDate()} / ${date.getMonth() + 1
                        } / ${date.getFullYear()}`}</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="success-modal-content-buttons">
                <button className="blue-button" style={{ display: "none" }}>
                  LEARN MORE ABOUT YOUR PERFORMANCE
                </button>
                <button className="blue-button" onClick={this.toDataCenter}>
                  SEE ALL YOUR RESULTS
                </button>
              </div>
              <IoMdClose
                size="32px"
                onClick={this.closeModal}
                className="modal-close"
              />
            </div>

            <div className="success-modal-sidebar">
              <div className="modal-sidebar-item">
                <h6>How would you rate the content?</h6>
                <Rater total={5} onRate={this.changeRating}>
                  <Star />
                </Rater>
              </div>
              <div style={{ display: "none" }} className="modal-sidebar-item">
                <h6>How do you feel?</h6>
                <Rater total={5} onRate={this.feelRating}>
                  <Sad />
                  <Angry />
                  <Normal />
                  <Smile />
                  <Happy />
                </Rater>
              </div>
              <div style={{ display: "none" }} className="modal-sidebar-item">
                <h6>Add this lesson to your training?</h6>
                <IoIosArrowForward size="45px" />
              </div>
              <div className="modal-sidebar-item" style={{ display: "none" }}>
                <h6>Your next Performance Learning Pathway</h6>
                <p>Next Lesson Name</p>
              </div>
            </div>
          </div>
        </Modal>
      );
    } else {
      return "";
    }
  }
  public renderCompletedPage() {
    return (
      <div>
        <div className="assessment-complete-container">
          <p className="thank-you">Great Work!</p>
          <p className="you-completed">{`Let's head over to your Dashboard`}</p>
          <br />
          {this.actionbuttons()}
          {/* <PlexLoader />  to be revised*/}
        </div>
        {this.feedbackModal()}
      </div>
    );
  }
  public chooseRender() {
    const count = this.state.counter;
    const assessmentQuestions = this.state.assessment[
      this.state.assessmentfields.questions
    ];
    if (assessmentQuestions) {
      return count < assessmentQuestions.length
        ? this.renderAssessment()
        : this.renderCompletedPage();
    } else {
      return <Loader color="#3ee9f7" />;
    }
  }

  public render() {
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }
    if (this.state.toProfile === true) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }
    if (this.state.todashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }
    if (this.state.tocompleted === true) {
      return (
        <Redirect
          to={this.state.baseurl + "assessmentcompleted/" + this.currentid()}
        />
      );
    }
    const Styles = {
      toast: {
        zIndex: 9999999,
      },
      welcometext: {
        margin: 0,
        marginTop: "2%",
      },
    };
    return (
      <div>
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} onLogoClick={this.onLogoClick} />
        <ToastContainer style={Styles.toast} />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          {this.chooseRender()}
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(UpgradedAssessmentViewPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/upgradedAssessmentViewPage.Component.tsx